// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RDA9","badges":"styles_badges__NMWBM"};